<template>
  <div>
    <div>

      <div class="layout-breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item href="#" >
            <span style="color:#fff;">基础管理</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
          <span style="color:#fff;">库区库位管理</span>
          </Breadcrumb-item>
        </Breadcrumb>
      </div>

      <div class="layout-content">
        <div class="layout-content-main">
          <div class="treeLeft">
             
            <Button type="primary" @click="addWarehouse" v-if="warehouseBut.addBut">＋</Button>
             <!-- v-on:addDate = 'editWarehouse'  //新增按钮新增--> 
             <div class="canNot" v-if="!warehouseBut.selectBut"> 暂无查看仓库权限 </div>
             <warehouse-tree
             :deptData = "warehouseLists"
             :selectedId = "dePtNodeSelect" 
             v-on:getCurrDate = 'getCurr'
             v-if="warehouseBut.selectBut"
             
             ></warehouse-tree>
              
          </div>
          <div class="treeRight">
            <div>
              <div class="houseTitle">仓库管理</div>
              <!-- <div class="infoRed" v-if="editMsg">请录入仓库信息！</div> -->
              <div class="canNot" v-if="!warehouseBut.selectBut"> 暂无查看仓库权限 </div>
              <Form ref="formWarehouse" :model="formWarehouse" :rules="ruleWarehouse" :label-width="86" v-if="warehouseBut.selectBut">
                  <div class="formLine" >
                     <!-- <FormItem label="供应商代码" prop="supplierId">
                        <Input :disabled="!editMsg" v-model="formWarehouse.supplierId" placeholder=""></Input>
                    </FormItem>
                     <FormItem label="供应商名称" prop="supplierName">
                        <Input :disabled="!editMsg" v-model="formWarehouse.supplierName" placeholder=""></Input>
                    </FormItem> -->
                    <FormItem label="供应商代码" prop="supplierId">
                        <Select :disabled="!editMsg" v-model="formWarehouse.supplierId" placeholder="请选择供应商代码"  @on-change="mySupplierIdChange" >
                            <Option :value="item.dlvSiteName"  :class="[formWarehouse.supplierId == item.dlvSiteCode ? 'ivu-select-selected-value' : '']"  v-for="item in supplierDate" >{{item.dlvSiteCode}}</Option>
                        </Select>
                    </FormItem>
                     <FormItem label="供应商名称" prop="supplierName">
                        <Select :disabled="!editMsg" v-model="formWarehouse.supplierName" placeholder="请选择供应商名称" @on-change="mySupplierNameChange">
                            <Option :value="item.dlvSiteCode" :class="[formWarehouse.supplierName == item.dlvSiteCode ? 'ivu-select-selected-value' : '']"  v-for="item in supplierDate"  label-in-value="true">{{item.dlvSiteName}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="仓库代码" prop="warehouseId">
                      <Input  :disabled="!editMsg" v-model="formWarehouse.warehouseId" placeholder=""></Input>
                    </FormItem>
                  </div>
                  <div class="formLine" >
                     <FormItem label="仓库名称" prop="warehouseName">
                        <Input :disabled="!editMsg" v-model="formWarehouse.warehouseName" placeholder=""></Input>
                    </FormItem>
                     <FormItem label="仓库容量" prop="warehouseSize">
                        <Input :disabled="!editMsg" v-model="formWarehouse.warehouseSize" placeholder=""></Input>
                    </FormItem>
                    <FormItem label="仓库类型" prop="warehouseType">
                        <Select :disabled="!editMsg" v-model="formWarehouse.warehouseType" placeholder="请选择仓库类型">
                        
                            <Option value="10" :class="[formWarehouse.warehouseType == '10' ? 'ivu-select-selected-value' : '']"  >自有</Option>
                            <Option value="20" :class="[formWarehouse.warehouseType == '20' ? 'ivu-select-selected-value' : '']">他人</Option>
                        </Select>
                    </FormItem>
                  </div>
                   <div class="formLine">
                      <FormItem label="是否默认" prop="isDefault" style="text-align:left;">
                          <RadioGroup  v-model="formWarehouse.isDefault">
                            <Radio :disabled="!editMsg" label="1" :class="[formWarehouse.isDefault == '1' ? 'ivu-radio-checked' : '']">是</Radio>
                            <Radio :disabled="!editMsg" label="0" :class="[formWarehouse.isDefault == '0' ? 'ivu-radio-checked' : '']">否</Radio>
                          </RadioGroup>
                      </FormItem>
                      <FormItem label="仓库联系人" prop="contact">
                        <Input :disabled="!editMsg" v-model="formWarehouse.contact" placeholder=""></Input>
                      </FormItem>
                      <FormItem label="联系人电话" prop="contactPhone">
                        <Input :disabled="!editMsg" v-model="formWarehouse.contactPhone" placeholder=""></Input>
                      </FormItem>
                  </div>
                  <FormItem label="地址" prop="address">
                    <Input :disabled="!editMsg" v-model="formWarehouse.address" placeholder=""></Input>
                  </FormItem>
                 
                  <FormItem>
                      <Button type="primary" :disabled="addDisabled" class="mRight"  @click="warehouseSubmit('formWarehouse')">保存仓库</Button>
                      <Button type="primary"  class="mRight" @click="warehouseUpdate('formWarehouse')" v-if="warehouseBut.updateBut">修改仓库</Button>
                      <Button type="primary" class="mRight" @click="delWarehouseMod = true" v-if="warehouseBut.delBut">删除仓库</Button>
                      <Button :disabled="addDisabled" type="ghost" class="mRight"  @click="warehouseReset('formWarehouse')">取消</Button>
              
                  </FormItem>
              </Form>
                
            </div>
             <div>
              <div class="houseTitle">库区管理</div>
              <div class="method-wrapper">
                    <Button @click="addReservoir" type="primary" class="mRight" v-if="reservoirBut.addBut">新增库区</Button>
                    <Button @click="upDateReservoir" type="primary" class="mRight" v-if="reservoirBut.updateBut">修改库区</Button>
                    <Button type="primary" class="mRight" @click="delReservoir" v-if="reservoirBut.delBut">删除库区</Button>
              
              </div>
              <div class="table-wrapper">
                    <div class="canNot" v-if="!reservoirBut.selectBut"> 暂无查看库区权限 </div>
                    <Table style="min-width: 600px;margin-bottom:20px;" border :columns="columnsReservoir" :data="reservoirData.data" ref="reservoirSelect" @on-selection-change="reservoirSelected" v-if="reservoirBut.selectBut"></Table >
                    <!-- <div style="margin: 10px;overflow: hidden">
                        <div style="float: right;">
                             <Page :total="reservoirData.page.totalCount" @on-change="onChangeReservoir"  show-sizer show-elevator show-total  @on-page-size-change="sizeChangeReservoir"></Page>
                        </div>
                    </div> -->
              </div>
              <div class="clearfix"></div>
            </div>
            <div>
              <div class="houseTitle">库位管理</div>
              <div class="method-wrapper">
                    <Button @click="addLocation" type="primary" class="mRight" v-if="locationBut.addBut">新增库位</Button>
                    <Button @click="upDateLocation" type="primary" class="mRight" v-if="locationBut.updateBut">修改库位</Button>
                    <Button type="primary" class="mRight" @click="delLocation" v-if="locationBut.delBut">删除库位</Button>
                    
                   
              </div>
              <div class="table-wrapper">
                    <div class="canNot" v-if="!locationBut.selectBut"> 暂无查看库位权限 </div>
                    <Table style="min-width: 600px;" border :columns="columnsLocation" :data="locationData.data" ref="selection" @on-selection-change="locationSelected" v-if="locationBut.selectBut"></Table >
                    <div style="margin: 10px;overflow: hidden">
                        <div style="float: right;">
                             <Page :total="locationData.page.totalCount" @on-change="onChangeLocation"  show-sizer show-elevator show-total  @on-page-size-change="sizeChangeLocation"></Page>
                        </div>
                    </div>
              </div>
              <div class="clearfix"></div>
            </div>

          </div>

        </div>
      </div>

    </div>

  <!-- 新增库区  / 修改-->
    <Modal
      v-model="ReservoirModel"
      title="新增" :mask-closable="false">
        <p slot="header" style="text-align:center">
            <Icon type="information-circled"></Icon>
            <span>{{ReservoirName}}</span>
        </p>
        <div style="text-align:center">
          <Form ref="reservoirValidate" :model="reservoirValidate" :rules="ruleReservoir" :label-width="80">
              <FormItem label="库区代码" prop="reservoirId">
                  <Input v-model="reservoirValidate.reservoirId" placeholder="请输入库区代码"></Input>
              </FormItem>
              <FormItem label="库区名称" prop="reservoirName">
                  <Input v-model="reservoirValidate.reservoirName" placeholder="请输入库区名称"></Input>
              </FormItem>
              <FormItem label="默认入库" prop="isIn" style="text-align:left;">
                  <RadioGroup v-model="reservoirValidate.isIn">
                    <Radio label="1" :class="[reservoirValidate.isIn == '1' ? 'ivu-radio-checked' : '']">是</Radio>
                    <Radio label="0" :class="[reservoirValidate.isIn == '0' ? 'ivu-radio-checked' : '']">否</Radio>
                  </RadioGroup>
              </FormItem>
              <FormItem label="默认出库" prop="isOut" style="text-align:left;">
                  <RadioGroup v-model="reservoirValidate.isOut">
                    <Radio label="1" :class="[reservoirValidate.isOut == '1' ? 'ivu-radio-checked' : '']">是</Radio>
                    <Radio label="0" :class="[reservoirValidate.isOut == '0' ? 'ivu-radio-checked' : '']">否</Radio>
                  </RadioGroup>
              </FormItem>
          </Form>
        </div>
        <div slot="footer">
             <Button type="primary" @click="submitReservoir('reservoirValidate')" long   :loading="modal_loading" >确定</Button>
        </div>
    </Modal>

<!-- 新增库位  / 修改-->
    <Modal
      v-model="LocationModel"
      title="新增" :mask-closable="false">
        <p slot="header" style="text-align:center">
            <Icon type="information-circled"></Icon>
            <span>{{LocationName}}</span>
        </p>
        <div style="text-align:center">
          <Form ref="locationValidate" :model="locationValidate" :rules="ruleLocation" :label-width="85">
              <FormItem label="库位代码" prop="locationId">
                  <Input v-model="locationValidate.locationId" placeholder="请输入库位代码"></Input>
              </FormItem>
              <FormItem label="库位名称" prop="locationName">
                  <Input v-model="locationValidate.locationName" placeholder="请输入库位名称"></Input>
              </FormItem>
              <FormItem label="库位描述" prop="locationInfo">
                  <Input v-model="locationValidate.locationInfo" placeholder="请输入库位描述"></Input>
              </FormItem>
              <FormItem label="宽度上限" prop="locationMax">
                  <Input v-model="locationValidate.locationMax" placeholder="请输入宽度上限"></Input>
              </FormItem>
              <FormItem label="宽度下线" prop="locationMin">
                  <Input v-model="locationValidate.locationMin" placeholder="请输入宽度下线"></Input>
              </FormItem>
              <FormItem label="额定捆包数" prop="locationNum">
                  <Input v-model="locationValidate.locationNum" placeholder="请输入额定捆包数"></Input>
              </FormItem>
              
          </Form>
        </div>
        <div slot="footer">
             <Button type="primary" @click="submitLocation('locationValidate')" long   :loading="modal_loading" >确定</Button>
        </div>
    </Modal>
    <Modal
        title="Title"
        v-model="delWarehouseMod"
        :mask-closable="false">
        <p slot="header" style="text-align:center">
            <Icon type="information-circled"></Icon>
            <span>确认删除</span>
        </p>
        <div style="text-align:center">
            删除仓库会删除该仓库及下面所有的库区、库位。<br/>
            您确定删除吗？
        </div>
        
         <div slot="footer">
             <Button type="default" @click="delWarehouseMod = false" >取消</Button>
             <Button type="primary" @click="delWarehouse('formWarehouse')" >确定</Button>
        </div>
    </Modal>
  
  </div>
</template>
<style scoped >
.layout-content-main{
  overflow: hidden;
}
.treeLeft{
  width:190px;
  height: 100%;
  position: absolute;
  border-right: solid 2px #eee;
}

.treeRight{
  margin-left:200px;
  overflow:hidden;
}
.houseTitle{
  width:100%;
  height: 40px;
  line-height: 40px;
  color: #fff;
  background: #495060;
  padding: 0 15px;
  margin-bottom: 20px;
  font-size: 16px;
}
.table-wrapper {
  overflow: scroll;
  float: left;
  width: 100%;
}
.method-wrapper {
  float: left;
  margin: 0 0 15px 15px;
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}
.mRight{
  margin-right:10px;
}
.mLeft{
  margin-left:10px;
}
.ivu-breadcrumb a{
  color:#fff !important;
}
.formLine{
  display: flex;
}
.formLine .ivu-form-item{
  flex:1;
  margin-bottom: 20px;
}
.infoRed{
  color:#ed3f14;
  font-size: 16px;
  margin-bottom: 20px;
}
.canNot{
  margin:20px 10px;
}
</style>
<script>
  import api from '../../api/apinew'
  import axios from 'axios'
  import Qs from 'qs'
  import treeCom from '../../components/tree'
  import warehouseTree from '../../components/warehouseTree' 

  export default{
    data(){
       const validateLocationMax= (rule, value, callback) => {
          if (value === '') {
              callback(new Error('宽度上限不能为空'));
          } else {
              callback();
          }
       };
       const validateLocationMin= (rule, value, callback) => {
          if (value === '') {
              callback(new Error('宽度上限下能为空'));
          } else {
              callback();
          }
       };
       const validateLocationNum= (rule, value, callback) => {
          if (value === '') {
              callback(new Error('额定捆包数不能为空'));
          } else {
              callback();
          }
       };
      
      const validateNum = (rule, value, callback) =>{
        if(value == ''){
          callback(new Error('仓库容量不能为空！'));
        }
        // 模拟异步验证效果
        setTimeout(() => {
            if (!/^[0-9]*$/.test(value)) {
              callback(new Error('仓库容量必须是数字'));
            } else {
              callback();
            }
        }, 200);
      };
      return {
       warehouseBut:{
        selectBut:false,
        addBut:false,
        updateBut:false,
        delBut:false,
       },
       reservoirBut:{
        selectBut:false,
        addBut:false,
        updateBut:false,
        delBut:false,
      },
      locationBut:{
        selectBut:false,
        addBut:false,
        updateBut:false,
        delBut:false,
      },
       addDisabled:true,
       editMsg:false,
       delWarehouseMod:false,
        formWarehouse: {
            supplierId: '',
            supplierName: '',
            warehouseId: '',
            warehouseName: '',
            warehouseSize: '',
            warehouseType: '',
            isDefault: '',
            contact: '',
            contactPhone: '',
            address: '',
            id:''
        },
        ruleWarehouse: {
            supplierId: [
                { required: true, message: '供应商代码不能为空', trigger: 'blur' }
            ],
            supplierName: [
                { required: true, message: '供应商名称不能为空', trigger: 'blur' }
            ],
            warehouseId: [
                { required: true, message: '仓库代码不能为空', trigger: 'blur' }
            ],
            warehouseName: [
                { required: true, message: '仓库名称不能为空', trigger: 'blur' }
            ],
            warehouseSize: [
                { required: true,validator:validateNum,trigger: 'blur' },
                // { required: true, message: '仓库容量不能为空', trigger: 'blur' }
            ],
            warehouseType: [
                { required: true, message: '仓库类型不能为空', trigger: 'blur' }
            ],
            warehouseType: [
                { required: true, message: '仓库类型不能为空', trigger: 'blur' }
            ],
            isDefault: [
                { required: true, message: '请选择是否默认', trigger: 'change' }
            ],
            contact: [
                 { required: true, message: '联系人不能为空', trigger: 'blur' }
            ],
            contactPhone: [
                { required: true, message: '手机号不能为空', trigger: 'blur' },
               {validator(rule, value, callback, source, options) {
                  var errors = [];
                  if(!/^1\d{10}$/.test(value)) {
                    // errors.push(
                        callback('手机号格式不正确');
                    }
                    callback(errors);
                }}
            ],
            address: [
                 { required: true, message: '地址不能为空', trigger: 'blur' }
            ],
           
        },
        reservoirValidate
        : {
            reservoirId: '',
            reservoirName: '',
            isIn: '',
            isOut: '',
        },
        ruleReservoir: {
            reservoirId: [
                { required: true, message: '库区代码不能为空', trigger: 'blur' }
            ],
            reservoirName: [
                { required: true, message: '库区名称不能为空', trigger: 'blur' }
            ],
            isIn: [
                { required: true, message: '是否默认入库不能为空', trigger: 'blur' }
            ],
            isOut: [
                { required: true, message: '是否默认出库不能为空', trigger: 'blur' }
            ],
        },
        locationValidate: {
            locationId: '',
            locationName: '',
            locationInfo: '',
            locationMax: '',
            locationMin: '',
            locationNum: '',
           
        },
        ruleLocation: {
            locationId: [
                { required: true, message: '库位代码不能为空', trigger: 'blur' }
            ],
            locationName: [
                { required: true, message: '库位名称不能为空', trigger: 'blur' }
            ],
            locationInfo: [
                { required: true, message: '库位描述不能为空', trigger: 'blur' }
            ],
            locationMax: [
                { required: true, validator:validateLocationMax, trigger: 'blur' }
            ],
            locationMin: [
                { required: true, validator:validateLocationMin, trigger: 'blur' }
            ],
            locationNum: [
                { required: true, validator:validateLocationNum, trigger: 'blur' }
            ]
        },
        LocationName:'新增库位', 
        ReservoirName:'新增库区',
        reservoirData:{  
           data:[],  
           page:{  
              //分页数  
               // arrPageSize:[10,20,30,40],  
               //分页大小  
               pagesize:10,  
               //总分页数  
               pageCount:1,  
               //当前页面  
               pageCurrent:1,  
               //总数  
               totalCount:0  
           }  

        },
        locationData:{  
           data:[],  
           page:{  
              //分页数  
               // arrPageSize:[10,20,30,40],  
               //分页大小  
               pagesize:10,  
               //总分页数  
               pageCount:1,  
               //当前页面  
               pageCurrent:1,  
               //总数  
               totalCount:0 ,
               areaId:'',
               id:''
           }  

        },
        columnsLocation:[
            {
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {   
                title: '库位代码',
                key:'locationId',
                width: 90,
                align: 'center'
            },
            {
                title: '库位名称',
                key: 'locationName',
                align: 'center'
            },
            {
                title: '库位描述',
                key: 'locationDesc',
                align: 'center'
            },
            {
                title: '宽度上限',
                key: 'specUpper',
                align: 'center'
            },
            {
                title: '宽度下限',
                key: 'specLower',
                align: 'center'
            },
            {
                title: '额定捆包数',
                key: 'topQuantity',
                align: 'center'
            },
        ],
        columnsReservoir:[
            {
                type: 'selection',
                width: 60,
                align: 'center',
            },
            {   
                title: '库区代码',
                key:'areaId',
                align: 'center'
            },
            {
                title: '库区名称',
                key: 'areaName',
                align: 'center'
            },
            {
                title: '默认入库',
                key: 'defaultIn',
                align: 'center',
                render:(h, params) => {
                    const row = params.row;
                    const color = row.status === 1 ? 'success' : 'default';
                    const text = row.status === 1 ? '是' : '否';

                    return h('Button', {
                        props: {
                            type: color,
                            size: 'small'
                        }
                    }, text);
                }
            },
            {
                title: '默认出库',
                key: 'defaultOut',
                align: 'center',
                render:(h, params) => {
                    const row = params.row;
                    const color = row.status === 1 ? 'success' : 'default';
                    const text = row.status === 1 ? '是' : '否';

                    return h('Button', {
                        props: {
                            type: color,
                            size: 'small'
                        }
                    }, text);
                }
            },
        ],
        LocationModel: false,
        ReservoirModel: false,
        warehouseLists:[],
        reservoirRows:{},
        locationRows:{},
        permissionsLists:[],
        dePtNodeSelect:[],
        warehouseAct:'',
        modal_loading: false,
        supplierDate:[]
      
      }
    },
    mounted:function(){  
      // ----------- 权限显示start -------------
      var permissions = JSON.parse(localStorage.getItem('menuLeftLists'));
      // 获取当前的地址
      let path = this.$route.matched[1].path ;
      // console.log(this.permissionsLists)
      var len = permissions.length;
     
      for(var i=0;i<len;i++){
          if(path.indexOf(permissions[i].url) != -1){
             this.permissionsLists =  permissions[i].list
          }
      }
      console.log(this.permissionsLists)
      // 获取权限
      this.permissionsLists.forEach(r=>{
        // console.log(r.name)

        if(r.name == "查看"){
          this.warehouseBut.selectBut = true;
        }else if(r.name == "新增"){
          this.warehouseBut.addBut = true;
        }else if(r.name == "修改"){
          this.warehouseBut.updateBut = true;
        }else if(r.name == "删除"){
           this.warehouseBut.delBut = true;
        }else if(r.name == "新增库区"){
          this.reservoirBut.addBut = true;
        }else if(r.name == "修改库区"){
          this.reservoirBut.updateBut = true;
        }else if(r.name == "删除库区"){
          this.reservoirBut.delBut = true;
        }else if(r.name == "查看库区"){
           this.reservoirBut.selectBut = true;
        }else if(r.name == "新增库位"){
          this.locationBut.addBut = true;
        }else if(r.name == "修改库位"){
          this.locationBut.updateBut = true;
        }else if(r.name == "删除库位"){
          this.locationBut.delBut = true;
        }else if(r.name == "查看库位"){
           this.locationBut.selectBut = true;
        }

      })
       // ----------- 权限显示end -------------

        // this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        this.getDepartment()
    },
    methods: {
        // 点击供应商代码联动出供应商名称
        mySupplierIdChange(value){
            this.formWarehouse.supplierName  = value;
        },
        // 点击供应商名称联动出供应商代码
        mySupplierNameChange(value){
            this.formWarehouse.supplierId  = value;
        },
        // 新增／修改仓库请求
        warehouseSubmit (name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                  api.warehouse.addWarehouse({
                      'providerNo':this.formWarehouse.supplierId,
                      'custProvName':this.formWarehouse.supplierName,
                      'wproviderId':this.formWarehouse.warehouseId,
                      'wproviderName':this.formWarehouse.warehouseName,
                      'warehouseCapacity':this.formWarehouse.warehouseSize,
                      'wproviderType':this.formWarehouse.warehouseType,
                      'defaultWarehouse':this.formWarehouse.isDefault,
                      'wproviderContract':this.formWarehouse.contact,
                      'contractTel':this.formWarehouse.contactPhone,
                      'wproviderAddress':this.formWarehouse.address,
                  }, resp => {
                      // console.log(resp)
                      if(resp.code == 0){
                          this.$Message.success(this.warehouseAct+'成功');
                      }
                      this.editMsg = false; //禁用编辑仓库
                      this.addDisabled = true;  //禁用保存仓库
                      setTimeout(function(){
                          // 刷新当前页面
                          location.reload() 
                      }, 300 )
                      
                  }, error => {

                  })
                } else {
                    this.$Message.error('Fail!');
                }
            })
        },
        // 新增仓库准备
        addWarehouse:function(){
          this.warehouseAct = "新增仓库";
          this.editMsg = true; //解除禁用编辑仓库
          this.warehouseReset('formWarehouse');  //置空仓库数据
          this.addDisabled = false;  //可以保存仓库
          this.reservoirData.data = [];//置空库区数据
          this.locationData.data  = [];//置空库位置数据
          // 供应商请求获取数据
          api.supplier.getList({
              'page':1,
              'limit':10,
          }, resp => {
              console.log(resp);
               this.supplierDate = resp.page.list;

          }, error => {

          })

        },
        // 修改仓库
        warehouseUpdate:function(){
          this.warehouseAct = "修改仓库";
          this.editMsg = true; //添加仓库
          this.addDisabled = false;  //可以保存仓库
        },
        // 重置仓库数据
        warehouseReset (name) {
            this.$refs[name].resetFields();
        },
        // 获取仓库下所有的库区
        getListsReservoir(pageCurrent,pagesize){
            api.warehouse.storageLists({
                'page':pageCurrent,
                'limit':pagesize,
            }, resp => {
              console.log(resp)
               // 获取分页展示list
                this.reservoirData.data = [];
                this.reservoirData.data = resp.page.list;
                this.reservoirRows = {};
                if(this.reservoirData.data.length !== 0){
                    this.reservoirData.data.forEach(r=>{
                      r._checked = false
                    }) //其他项目不勾选

                    this.reservoirData.data[0]._checked = true;  //默认选中第一行
                    console.log(this.reservoirData.data[0])
                    this.reservoirRows = this.reservoirData.data;
                    this.locationData.page.areaId = this.reservoirData.data[0].areaId;
                 }else{
                    this.locationData.page.areaId = '';
                 }
               // // 获取分页总条数
               this.reservoirData.page.totalCount = resp.page.totalCount;
            }, error => {

            })
        },
        // 获取库区下所有的库位
        getListsLocation(pageCurrent,pagesize,areaId){
            api.warehouse.locationLists({
                'page':pageCurrent,
                'limit':pagesize,
                'areaId':areaId
            }, resp => {
              console.log(resp)
               // 获取分页展示list
               // if(resp.page.list.length !== 0){
                 this.locationData.data = resp.page.list;
               // }
               
               // // 获取分页总条数
               this.locationData.page.totalCount = resp.page.totalCount;
            }, error => {

            })
        },
        // 获得左侧树
        getDepartment:function(){
            api.warehouse.getTree({

            }, resp => {
              // console.log(resp)
              this.warehouseLists = resp.list; 
             
            }, error => {
              
            })
        },
        // 展示当前仓库内容
        showWearhouse:function(curId){
          // console.log(curId)
            api.warehouse.storageInfo(
                curId
            , resp => {
              // console.log(resp)
               // 获取分页展示list
                this.formWarehouse = {
                    supplierId: resp.warehouse.providerNo,
                    supplierName: resp.warehouse.custProvName,
                    warehouseId: resp.warehouse.wproviderId,
                    warehouseName: resp.warehouse.wproviderName,
                    warehouseSize: resp.warehouse.warehouseCapacity,
                    warehouseType: resp.warehouse.wproviderType,
                    isDefault: resp.warehouse.defaultWarehouse,
                    contact: resp.warehouse.wproviderContract,
                    contactPhone: resp.warehouse.contractTel,
                    address: resp.warehouse.wproviderAddress,
                    id:resp.warehouse.id
                };


               // 获取库区分页展示list
               this.reservoirData.data = resp.storageAreaList; //获取当前库区
               // 默认选中第一条
               this.reservoirRows = {};
               if(this.reservoirData.data.length !== 0){
                    this.reservoirData.data.forEach(r=>{
                      r._checked = false
                    }) //其他项目不勾选
                    this.reservoirData.data[0]._checked = true;  //默认选中第一行
                    this.reservoirRows = this.reservoirData.data;
                    this.locationData.page.areaId = this.reservoirData.data[0].areaId;  //获取当前库区ID
                 }else{
                    this.locationData.page.areaId = '';
                 }


               // 根据当前库区ID获取库区下面的库位
               this.getListsLocation(this.locationData.page.pageCurrent,this.locationData.page.pagesize,this.locationData.page.areaId); //请求获取库区接口


            }, error => {

            })
           
        },
        //获取到选中节点携带的数据
        getCurr:function(date){  
          // console.log(date) 
          this.editMsg = false; //禁用编辑仓库
          this.addDisabled = true;  //禁用保存仓库

          this.dePtNodeSelect = [];  //置空当前树节点选中Id
          this.dePtNodeSelect.push(date.selectedId)  //赋值

          // 判断当前选中数据中是否有children对象
          if( !date.node[0].hasOwnProperty("children")){
            // 有，调用根据当前库区获取仓库信息及当前库区的信息
            this.showWearhouse(this.dePtNodeSelect[0]); //展示仓库
          }else{
            //没有，根据仓库ID获取仓库信息，以及当前仓库下的所有库区
            this.getWhList(this.dePtNodeSelect[0])
          }
          
        },
         // 当前库区选中项
        reservoirSelected:function(selection){
            // console.log(selection)
            this.reservoirRows = {};
            this.reservoirRows = selection;
            // return selection;
        },
        // 当前库位表格选中项
        locationSelected:function(selection){
            // console.log(selection)
            this.locationRows = {};
            this.locationRows = selection;
            // return selection;
        },
        // 分页 -- 页数改变
        onChangeReservoir:function(curpage){  
            // alert("当前页面页码是：" + curpage);
            // console.log(curpage)
            this.reservoirData.page.pageCurrent = curpage;
            this.getListsReservoir(this.reservoirData.page.pageCurrent,this.reservoirData.page.pagesize);
        },
        onChangeLocation:function(curpage){  
            // alert("当前页面页码是：" + curpage);
            this.locationData.page.pageCurrent = curpage;
            this.getListsLocation(this.locationData.page.pageCurrent,this.locationData.page.pagesize,this.locationData.page.areaId);
        },
        // 分页 -- pageSize 改变
        sizeChangeReservoir:function(size){
         // alert("当前页面size是：" + size);
          this.reservoirData.page.pagesize = size;
          this.getListsReservoir(this.reservoirData.page.pageCurrent,this.reservoirData.page.pagesize);
        } ,
        sizeChangeLocation:function(size){
         // alert("当前页面size是：" + size);
          this.locationData.page.pagesize = size;
          this.getListsLocation(this.locationData.page.pageCurrent,this.locationData.page.pagesize,this.locationData.page.areaId);
        } ,
        // 删除仓库
        delWarehouse:function(){
           var warehouseId = this.formWarehouse.id;
            // console.log(warehouseId)
            api.warehouse.delWarehouse( warehouseId , resp => {
               console.log(resp)
               if(resp.code == 0){
                 this.$Message.success('删除仓库成功!');
                 setTimeout(function(){
                      // 刷新当前页面
                      location.reload() 
                 }, 200 )
                 // this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
               }else{
                 this.$Message.error(resp.msg);
               }
              
                
             
            }, error => {
                this.$Message.error(resp.msg);
              
            })

            this.delWarehouseMod = false;
         
        },
        // 新增库区准备
        addReservoir:function(){

           this.ReservoirName = '新增库区';
            this.reservoirValidate = {
              reservoirId: '',
              reservoirName: '',
              isIn: '',
              isOut: '',
            }

          this.ReservoirModel = true;
        },
        // 修改库区准备
        upDateReservoir:function(){
          this.ReservoirName = '修改库区';
          if(this.reservoirRows.length == undefined || this.reservoirRows.length == 0){
              this.$Message.error('请选择一条记录!');
              return;
          }
          if(this.reservoirRows.length > 1){
             this.$Message.error('一次只能选择一个进行修改!');
             return;
          }
          
          // console.log(this.reservoirRows)
          this.updateLocationId = this.reservoirRows[0];
         
          this.reservoirValidate = {
              reservoirId: this.reservoirRows[0].areaId,
              reservoirName: this.reservoirRows[0].areaName,
              isIn: this.reservoirRows[0].defaultIn,
              isOut: this.reservoirRows[0].defaultOut,
             
          },

          this.ReservoirModel = true;

        },
        // 删除库区请求
        delReservoir:function(){
              if(this.reservoirRows.length == undefined || this.reservoirRows.length == 0){
                this.$Message.error('请选择一条记录!');
                return;
              }
              if(this.reservoirRows.length > 1){
                 this.$Message.error('一次只能删除一个!');
                 return;
              }
              var id = [];
              var len = this.reservoirRows.length;

              for(var i=0;i<len;i++){
                id.push(this.reservoirRows[i].id)
                  
              }
            
             api.warehouse.delStorage(id , resp => {
               // console.log(resp)
               if(resp.code == 0){
                 this.$Message.success('删除库区成功!');
                 // this.getListsReservoir(this.reservoirData.page.pageCurrent,this.reservoirData.page.pagesize);
                 this.dePtNodeSelect = [];  // 置空当前选中库区
               }
             
            }, error => {
              
            })

        },
        // 新增库位准备
        addLocation:function(){
           this.LocationName = '新增库位';
            this.locationValidate = {
              locationId: '',
              locationName: '',
              locationInfo: '',
              locationMax: '',
              locationMin: '',
              locationNum: '',
            }
          this.LocationModel = true;

        },
        // 删除库位请求
        delLocation:function(){
            if(this.locationRows.length == undefined || this.locationRows.length == 0){
               this.$Message.error('请至少选择一条记录!');
                return;
            }
            var locationIds = [];
            for(var i=0 ;i < this.locationRows.length; i++){
                console.log(i);
                locationIds.push(this.locationRows[i].id);
            }
            // console.log(locationIds)
            api.warehouse.delLocation(locationIds , resp => {
               // console.log(resp)
               if(resp.code == 0){
                 this.$Message.success('删除库位成功!');
                 this.getListsLocation(this.locationData.page.pageCurrent,this.locationData.page.pagesize,this.locationData.page.areaId);
               }
             
            }, error => {
              
            })

        },
        // 修改库位准备
        upDateLocation:function(){
           this.LocationName = '修改库位';
            // locationRows:{},
            if(this.locationRows.length == undefined || this.locationRows.length == 0){
                this.$Message.error('请选择一条记录!');
                return;
            }
            if(this.locationRows.length > 1){
               this.$Message.error('一次只能选择一个进行修改!');
               return;
            }
            // console.log(this.locationRows)
            this.updateLocationId = this.locationRows[0].locationId;
           
            this.locationValidate = {
                locationId: this.locationRows[0].locationId,
                locationName: this.locationRows[0].locationName,
                locationInfo: this.locationRows[0].locationDesc,
                locationMax: this.locationRows[0].specUpper,
                locationMin: this.locationRows[0].specLower,
                locationNum: this.locationRows[0].topQuantity,
                id:this.locationRows[0].id,
               
            },
            // console.log( this.locationValidate)
            this.LocationModel = true;

        },
        // 新增、修改库区请求
        submitReservoir:function(name){
          this.$refs[name].validate((valid) => {
               // console.log(valid)
                if (valid) {
                  // console.log(this.formWarehouse.warehouseId)
                  // console.log(this.ReservoirName)
                  if(this.ReservoirName == "修改库区"){
                      // console.log(this.reservoirRows)
                    api.warehouse.updateStorage({
                      "id":this.reservoirRows[0].id,
                      "warehouseId": this.formWarehouse.warehouseId,
                      "areaId": this.reservoirValidate.reservoirId,
                      "areaName": this.reservoirValidate.reservoirName,
                      "defaultIn": this.reservoirValidate.isIn,
                      "defaultOut": this.reservoirValidate.isOut,
                    }, resp => {
                      // console.log(resp)
                      if(resp.code == 0){
                        this.$Message.success('修改库区成功!');
                        this.ReservoirModel = false;

                        setTimeout(function(){
                            // 刷新当前页面
                            location.reload() 
                        }, 300 )
                         
                        // this.getListsReservoir(this.reservoirData.page.pageCurrent,this.reservoirData.page.pagesize);
                      }

                    }, error => {

                    })
                  }else if(this.ReservoirName == "新增库区"){
                    api.warehouse.addStorage({
                      "wproviderId": this.formWarehouse.warehouseId,
                      "areaId": this.reservoirValidate.reservoirId,
                      "areaName": this.reservoirValidate.reservoirName,
                      "defaultIn": this.reservoirValidate.isIn,
                      "defaultOut": this.reservoirValidate.isOut,
                    }, resp => {
                      console.log(resp)
                      if(resp.code == 0){
                        this.$Message.success('新增库区成功!');
                        this.ReservoirModel = false;
                        // this.getListsReservoir(this.reservoirData.page.pageCurrent,this.reservoirData.page.pagesize);
                        setTimeout(function(){
                            // 刷新当前页面
                            location.reload() 
                        }, 300 )
                      }else{
                        this.$Message.error(resp.msg);
                      }
                      

                    }, error => {

                    })
                  }
                  
                    
                } else {
                    this.$Message.error('操作失败!');
                }
            })


        },
        // 新增、修改库位置请求
        submitLocation:function(name){
             this.$refs[name].validate((valid) => {
                if (valid) {
                  if(this.LocationName == "修改库位"){
                    api.warehouse.updateLocation({
                      "id":this.locationValidate.id,
                      "locationId": this.locationValidate.locationId,
                      "locationName": this.locationValidate.locationName,
                      "locationDesc": this.locationValidate.locationInfo,
                      "specUpper": this.locationValidate.locationMax,
                      "specLower": this.locationValidate.locationMin,
                      "topQuantity": this.locationValidate.locationNum,
                    }, resp => {
                      // console.log(resp)
                      if(resp.code == 0){
                        this.$Message.success('修改库位成功!');
                        this.LocationModel = false;
                        this.getListsLocation(this.locationData.page.pageCurrent,this.locationData.page.pagesize,this.locationData.page.areaId);
                      }else{
                       this.$Message.error(resp.msg);
                      }
                      

                    }, error => {

                    })
                  }else if(this.LocationName == "新增库位"){
                    // console.log(this.treeNodeId)
                    api.warehouse.addLocation({
                      "areaId":this.locationData.page.areaId,
                      "locationId": this.locationValidate.locationId,
                      "locationName": this.locationValidate.locationName,
                      "locationDesc": this.locationValidate.locationInfo,
                      "specUpper": this.locationValidate.locationMax,
                      "specLower": this.locationValidate.locationMin,
                      "topQuantity": this.locationValidate.locationNum,
                    }, resp => {
                      console.log(resp)
                      if(resp.code == 0){
                        this.$Message.success('新增库位成功!');
                        this.LocationModel = false;
                        this.getListsLocation(this.locationData.page.pageCurrent,this.locationData.page.pagesize,this.locationData.page.areaId);
                      }
                      

                    }, error => {

                    })
                  }
                  
                    
                } else {
                    this.$Message.error('操作失败!');
                }
            })
        },
        // 新增仓库准备
        // editWarehouse:function(data){
        //   // console.log(data)
        //   // this.editMsg = data.editMsg;
        //   this.dePtNodeSelect = []; //置空当前落色数组
        //   this.dePtNodeSelect.push(data.id);  //当前落色ID
        //   // 
        //   this.warehouseReset('formWarehouse');  //置空仓库数据
        //   this.addDisabled = false;  //可以保存仓库

        //   this.getWhList(data.wproviderId); //获取当前仓库下所有的库区

        // }, 
        // 获取当前仓库下所有库区
        getWhList:function(id){
            api.warehouse.whInfo(
              id, resp => {
              console.log(resp)
              if(resp.code == 0){
                 this.formWarehouse = {
                      supplierId: resp.jcTWarehouse.providerNo,
                      supplierName: resp.jcTWarehouse.custProvName,
                      warehouseId: resp.jcTWarehouse.wproviderId,
                      warehouseName: resp.jcTWarehouse.wproviderName,
                      warehouseSize: resp.jcTWarehouse.warehouseCapacity,
                      warehouseType: resp.jcTWarehouse.wproviderType,
                      isDefault: resp.jcTWarehouse.defaultWarehouse,
                      contact: resp.jcTWarehouse.wproviderContract,
                      contactPhone: resp.jcTWarehouse.contractTel,
                      address: resp.jcTWarehouse.wproviderAddress,
                  };
                 // 获取库区分页展示list
                 this.reservoirData.data = resp.jcTWarehouse.storageAreaList;
                  // 默认选中第一条
                 this.reservoirRows = {};
                 if(this.reservoirData.data.length !== 0){
                      this.reservoirData.data.forEach(r=>{
                        r._checked = false
                      }) //其他项目不勾选
                      this.reservoirData.data[0]._checked = true;  //默认选中第一行
                      this.reservoirRows = this.reservoirData.data;
                      // console.log(this.reservoirRows);
                      this.locationData.page.areaId = this.reservoirData.data[0].areaId;
                  }else{
                      this.locationData.page.areaId = '';
                  }

                 // 获取库区下面的库位
                 this.locationData.page.areaId = resp.jcTWarehouse.storageAreaList[0].areaId;
                 // console.log(this.locationData.page.areaId)
                 this.getListsLocation(this.locationData.page.pageCurrent,this.locationData.page.pagesize,this.locationData.page.areaId)

              }else{
                this.$Message.error(resp.msg);

              }

            }, error => {
                // this.$Message.error(resp.msg);
            })
        }



    },

      components: {treeCom,warehouseTree}
    }
</script>



// WEBPACK FOOTER //
// warehouse.vue?c675491a